"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getFirstElement = exports.getFirstElement = function getFirstElement(object) {
  return object[Object.keys(object)[0]];
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/clark-utils/lib/get-first-element/index.js
// module id = 582
// module chunks = 0